import { useState } from "react";
import mainContext from "./mainContext";
import dataContext from "./dataContext";

export const DataProvider = ({ children }) => {
  const [userDetails, setUserDetails] = useState(); //TODO the initial state need to be null
  const [pageName, setPageName] = useState("Dashboard");
  const [alreadiInit, setAlreadyInit] = useState(false);
  const [isShowHeader, setIsShowHeader] = useState(true);
  const [isShowNav, setIsShowNav] = useState(false);
  const [avatarGlobal, setAvatarGlobal] = useState(false);
  const [streamObj, setStreamObj] = useState(null)
  const [popup, setPopup] = useState(); // content of popup
  const [loaderFetch, setLoaderFetch] = useState(false)
  const [sumOfAssessments, setSumOfAssessments] = useState(0);
  const [serverData, setServerData] = useState({
    url: process.env.REACT_APP_SERVER_ENDPOINT,

  });
  const [examData, setExamData] = useState(null);
  const [assessmentId, setAssessmentId] = useState(null)
  return (
    <mainContext.Provider
      value={{
        popup: {
          popup,
          setPopup,
        },
        initCam: {
          alreadiInit,
          setAlreadyInit
        },
        header: {
          pageName,
          setPageName,
          isShowHeader,
          setIsShowHeader,
        },
        nav: {
          isShowNav,
          setIsShowNav,
        },
        avatarData: {
          avatarGlobal,
          setAvatarGlobal,
        },
        stream: {
          streamObj,
          setStreamObj,
        },
        loader: {
          loaderFetch,
          setLoaderFetch
        },
        TR_duration: 180
      }}
    >
      <dataContext.Provider value={{ sumOfAssessments, setSumOfAssessments, userDetails, setUserDetails, serverData, examData, setExamData, assessmentId, setAssessmentId }}>
        {children}
      </dataContext.Provider>
    </mainContext.Provider>
  );
};
